var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#020002"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5475 24.625L14.3125 20.5L17.75 19.125H21.875C22.2397 19.125 22.5894 18.9801 22.8473 18.7223C23.1051 18.4644 23.25 18.1147 23.25 17.75V9.5C23.25 9.13533 23.1051 8.78559 22.8473 8.52773C22.5894 8.26987 22.2397 8.125 21.875 8.125H8.125C7.76033 8.125 7.41059 8.26987 7.15273 8.52773C6.89487 8.78559 6.75 9.13533 6.75 9.5V17.75C6.75 18.1147 6.89487 18.4644 7.15273 18.7223C7.41059 18.9801 7.76033 19.125 8.125 19.125H14.3125V20.5H8.125C7.39565 20.5 6.69618 20.2103 6.18046 19.6945C5.66473 19.1788 5.375 18.4793 5.375 17.75V9.5C5.375 8.77065 5.66473 8.07118 6.18046 7.55546C6.69618 7.03973 7.39565 6.75 8.125 6.75H21.875C22.6043 6.75 23.3038 7.03973 23.8195 7.55546C24.3353 8.07118 24.625 8.77065 24.625 9.5V17.75C24.625 18.4793 24.3353 19.1788 23.8195 19.6945C23.3038 20.2103 22.6043 20.5 21.875 20.5H18.5475V24.625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 7.5H6.5V19.5L14.5 20.5H18L23.5 19.5V7.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.37f50be73f9be6920aff031abc01caa2.svg";
export { ForwardRef as ReactComponent };